.inner-container {
  display: flex;
  flex-direction: column;
  max-height: calc(-150px + 100vh);
  min-height: 300px;
  height: 100%;
  justify-content: center;
  gap: 12px;
  padding: 0 20px;
}

.cta-section {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 298px;
  width: 298px;
  margin: 24px auto 0;
}

.is-mobile-viewport .cta-section {
  gap: 8px;
}

.cta-wrapper {
  width: 100%;
}

.success-cta {
  width: 100%;
  background-color: var(--cta-bg-color);
  border-radius: calc(var(--cta-border-radius, 0) * 1px);
  cursor: pointer;
  height: 51px;
  border-style: solid;
  border-width: calc(var(--cta-border-width, 0) * 1px);
  border-color: var(--cta-border-color, transparent);
  padding: 0;
}

.success-cta p {
  margin: 0;
}

.success-cta * {
  pointer-events: none;
}

.is-mobile-viewport .success-cta {
  padding: 12px 24px;
}
